import type { IInventoryItem } from 'src/api/getInventory';

const getInventoryOptions = (items: IInventoryItem[]): { name: string; id: string }[] => {
  return items.map(({ name, recipe_id }) => ({ name: name, id: recipe_id }));
};
export default getInventoryOptions;
